/**
 * Browse's remembered choice: the view type, a terminal preference as v1 web's `VIEW_TYPE` is.
 * Persisted on both apps and kept across a logout.
 */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { ViewType } from "./model";

export interface NewOrderBrowseState {
  viewType: ViewType;
}

const initialState: NewOrderBrowseState = { viewType: "grid" };

const slice = createSlice({
  name: "newOrderBrowse",
  initialState,
  reducers: {
    viewTypeChosen: (state, action: PayloadAction<ViewType>) => {
      state.viewType = action.payload;
    },
  },
});

export const { viewTypeChosen } = slice.actions;
export const newOrderBrowseReducer = slice.reducer;

export const selectViewType = (state: any): ViewType => state?.newOrderBrowseStore?.viewType ?? "grid";
